import moment from 'moment';

import {
    SET_ILLNESS_RECREATION_PROPERTY_ID,
    SET_ILLNESS_RECREATION_DATA,
    SET_ILLNESS_RECREATION_DATA_LOADING,
    SET_ILLNESS_RECREATION_FILTER_OPTIONS,
    SET_ILLNESS_RECREATION_FILTERS,
    RESET_ILLNESS_RECREATION_FILTERS
} from '@/redux/mutations';

export const initialState = {
    property_id: null,
    data: {},
    loading: true,
    optionsFilters: {
        years: [moment().year()],
        months: [],
        illness: [],
        category: [],
        sex: [],
        isPurchased: []
    },
    selectedFilters: {
        years: [moment().year()],
        months: ['Todos'],
        illness: ['Todas'],
        category: ['Todos'],
        sex: 'Todos',
        isPurchased: 'Todos'
    }
};

const indicatorsPanelIllnessRecriationReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case SET_ILLNESS_RECREATION_PROPERTY_ID:
            return {
                ...state,
                property_id: actions.payload
            };
        case SET_ILLNESS_RECREATION_DATA:
            return {
                ...state,
                data: actions.payload
            };
        case SET_ILLNESS_RECREATION_DATA_LOADING:
            return {
                ...state,
                loading: actions.payload
            };
        case SET_ILLNESS_RECREATION_FILTER_OPTIONS:
            return {
                ...state,
                optionsFilters: actions.payload
            };
        case SET_ILLNESS_RECREATION_FILTERS:
            return {
                ...state,
                selectedFilters: actions.payload
            };
        case RESET_ILLNESS_RECREATION_FILTERS:
            return {
                ...state,
                selectedFilters: {
                    years: [moment().year()],
                    months: ['Todos'],
                    illness: ['Todas'],
                    category: ['Todos'],
                    sex: 'Todos',
                    isPurchased: 'Todos'
                }
            };
        default:
            return state;
    }
};

export default indicatorsPanelIllnessRecriationReducer;
